import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faPlay,
  faCircleNotch,
  faBuilding,
  faUsers,
  faCogs,
  faGlobeAsia,
  faSearchLocation,
  faRoad,
  faMapMarkerAlt,
  faEdit,
  faTrashAlt,
  faPowerOff,
  faCar,
  faCarSide,
  faTruckMoving,
  faTruckPickup,
  faTrailer,
  faPalette,
  faGasPump,
  faUserFriends,
  faTools,
  faExclamationTriangle,
  faPlusCircle,
  faUser,
  faPhoneSquareAlt,
  faPassport,
  faTimesCircle,
  faAd,
  faCalendarCheck,
  faBarcode,
  faListOl,
  faExchangeAlt,
  faCheckDouble,
  faClipboardList,
  faTimes,
  faCheckCircle,
  faPlus,
  faDotCircle,
  faSave,
  faFileWord,
  faPrint,
  faCalendarAlt,
  faSignInAlt,
  faCarCrash,
  faBurn,
  faQrcode,
  faKey,
  faUserEdit,
  faSortNumericUp,
  faChartArea,
  faHistory,
  faDownload,
  faBan,
  faInfoCircle,
  faSearch,
  faEnvelope,
  faCode,
  faTerminal,
  faBars,
  faHome,
  faMapSigns,
  faPhoneAlt,
  faMoneyCheckAlt,
  faCreditCard,
  faPortrait,
  faFolderPlus,
  faPaperclip,
  faCheck,
  faBell,
  faPaste,
  faUndo,
  faUserCog,
  faSearchPlus,
  faPlusSquare,
  faBackspace,
  faQuestionCircle,
  faReceipt,
  faSearchDollar,
  faSearchMinus,
  faTabletAlt,
  faLaptopCode,
  faLink,
  faSortNumericDown,
  faFileAlt,
  faCloudUploadAlt,
  faCamera,
  faDollarSign,
  faAngleDoubleLeft,
  faLeaf,
  faTaxi,
  faCopy,
  faMotorcycle,
  faVideo,
  faTruck,

} from '@fortawesome/free-solid-svg-icons'

import {
  faGoogle
} from "@fortawesome/free-brands-svg-icons";

import {faCalendarAlt as faCalendarAltRegular,} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faPlay,
  faCircleNotch,
  faBuilding,
  faUsers,
  faCogs,
  faGlobeAsia,
  faSearchLocation,
  faRoad,
  faMapMarkerAlt,
  faEdit,
  faTrashAlt,
  faPowerOff,
  faCar,
  faCarSide,
  faTruckMoving,
  faTruckPickup,
  faTrailer,
  faPalette,
  faGasPump,
  faUserFriends,
  faTools,
  faExclamationTriangle,
  faPlusCircle,
  faUser,
  faPhoneSquareAlt,
  faPassport,
  faTimesCircle,
  faAd,
  faCalendarCheck,
  faBarcode,
  faListOl,
  faExchangeAlt,
  faCheckDouble,
  faClipboardList,
  faTimes,
  faCheckCircle,
  faPlus,
  faDotCircle,
  faSave,
  faFileWord,
  faPrint,
  faCalendarAlt,
  faSignInAlt,
  faCalendarAltRegular,
  faCarCrash,
  faBurn,
  faQrcode,
  faKey,
  faUserEdit,
  faSortNumericUp,
  faChartArea,
  faHistory,
  faDownload,
  faBan,
  faInfoCircle,
  faSearch,
  faEnvelope,
  faCode,
  faTerminal,
  faBars,
  faHome,
  faMapSigns,
  faPhoneAlt,
  faMoneyCheckAlt,
  faCreditCard,
  faPortrait,
  faFolderPlus,
  faPaperclip,
  faCheck,
  faBell,
  faPaste,
  faUndo,
  faUserCog,
  faSearchPlus,
  faPlusSquare,
  faBackspace,
  faQuestionCircle,
  faReceipt,
  faSearchDollar,
  faSearchMinus,
  faTabletAlt,
    faLaptopCode,
    faLink,
    faSortNumericDown,
    faFileAlt,
    faCloudUploadAlt,
    faCamera,
    faDollarSign,
    faAngleDoubleLeft,
    faLeaf,
    faTaxi,
    faGoogle,
    faCopy,
    faMotorcycle,
    faVideo,
    faTruck
)

Vue.component('fa-icon', FontAwesomeIcon)
